module.exports = __webpack_public_path__ + "static/media/BM_Facility.b2c4c0c6.svg";